"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _HBPopover = require("./HBPopover.styles");
var _HBButton = _interopRequireDefault(require("../HBButton/HBButton"));
var _useWindowSize2 = require("../common/useWindowSize");
var HBPopoverActions = function HBPopoverActions(_ref) {
  var actions = _ref.actions,
    actionsAlignment = _ref.actionsAlignment,
    clickCallback = _ref.clickCallback,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 0 : _ref$marginTop,
    actionsOrientation = _ref.actionsOrientation;
  var _useWindowSize = (0, _useWindowSize2.useWindowSize)(),
    isUpToSmall = _useWindowSize.isUpToSmall;
  var isVerticalActions = actionsOrientation === 'vertical';
  return /*#__PURE__*/_react["default"].createElement(_HBPopover.ActionsContainer, {
    $actionsAlignment: actionsAlignment,
    $marginTop: marginTop,
    $isVertical: isVerticalActions
  }, actions.map(function (action) {
    return /*#__PURE__*/_react["default"].createElement(_HBPopover.ActionSpacer, {
      key: action.text,
      $isVertical: isVerticalActions
    }, /*#__PURE__*/_react["default"].createElement(_HBButton["default"], (0, _extends2["default"])({
      size: isUpToSmall ? 'lg' : 'xs',
      fullWidth: true,
      buttonTheme: action.theme
    }, action, {
      onClick: function onClick(e) {
        action.onClick(e, clickCallback);
      },
      disabled: action.disabled,
      testId: action.testIdName ? "hb-popover-".concat(action.testIdName, "-option--button") : undefined,
      testIdType: "hb-popover-option--button"
    }), action.text));
  }));
};
var _default = exports["default"] = HBPopoverActions;
//# sourceMappingURL=HBPopoverActions.js.map